module.exports = __webpack_public_path__ + "static/media/Sajek.d97a39d3.png";